module.exports = __webpack_public_path__ + "static/media/biohazard.cdfb567d.svg";